export function showPager() {
    const list = document.querySelectorAll('.panel');
    const pagination = document.querySelector('.pagination');
    if (!pagination) return;
    if (list.length >= 48) {
        pagination.classList.remove('hide');
    } else {
        pagination.classList.add('hide');
    }
}

export function setCurrentSort() {
    let currentSortColumn = 'ItemID';
    let currentSortOrder = 'asc';

    fetch('/my-unipol/getCurrentSort/')
        .then((resp) => {
            try {
                resp.json();
            } catch (e) {
                console.error(e);
            }
        })
        .then((data) => {
            if (!data) return;
            currentSortColumn = data.currentSortColumn;
            currentSortOrder = data.currentSortOrder;
            const currentSortLink = document.querySelector(
                `thead.sortable [data-sort-column=' ${currentSortColumn} ']`
            );
            currentSortLink.classList.add('sort');
            if (currentSortOrder === 'desc') {
                currentSortLink.addClass('desc');
            } else {
                currentSortLink.removeClass('desc');
            }
        });
}
